import { AreaVisitsIcon } from 'src/components/insights/icons/area-visits'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import dynamic from 'next/dynamic'
import preview from 'src/assets/images/widgets-previews/area-visits-daily-foot-traffic.png'

const AreaVisitsDailyFootTrafficCard = dynamic(() => import('src/components/insights/area-visits/day-of-week'), {
  ssr: false,
})

export const AreaVisitsDailyFootTrafficWidget: InsightBuilderWidget = {
  id: 'area-visits-daily-foot-traffic',
  name: 'Area Visits Daily Foot Traffic',
  type: 'Area Visits',
  icon: AreaVisitsIcon,
  component: AreaVisitsDailyFootTrafficCard,
  supportedResultTypes: ['alphamap-location'],
  preview,
  minTier: 'intermediate',
}
